





import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CardTitle extends Vue {
  @Prop() title!: string;
}
